(function($) {
  $(document).ready(function () {
    // Contact page
    $('.btn-contact-item').click(function() {
      var id = $(this).attr('href');
      if($(id).length>0) {
        $(id).toggleClass('active');
      }
    });
    $('.btn-close-contact-popup').click(function() {
      $(this).parents('#ContactForm-Popup').removeClass('active');
    });
    $(document).click(function(event) { 
      var $target = $(event.target);
      if(!$target.closest('.btn-contact-item').length &&!$target.closest('.ContactForm-PopupWrapper').length && $('.ContactForm-PopupWrapper').is(":visible")) {
        $('#ContactForm-Popup').removeClass('active');
      }        
    });

    if($('.ProductList-Swiper').length>0) {
      var swiper = new Swiper(".ProductList-Swiper", {
        slidesPerView: 4,
        spaceBetween: 30,
        scrollbar: {
          el: ".swiper-scrollbar"
        },
        breakpoints: {
          1: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          1008: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 30
          }
        }
      });
    }
  });
})(jQuery);